import React, { useContext, useEffect, useState, useRef } from 'react';
import {
  Box,
  Grid,
  GridItem,
  Img,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  Tooltip,
  Button,
} from '@chakra-ui/react';
import { useColor } from '../../../../components/ui/ColorContext';
import Scrollbar from 'components/customScroll/CustomScroll';
import { ScoreContext } from '../GamePreview';
import { DivideCircle } from 'lucide-react';
// import NewBackground_2 from '../../../../assets/glb/NewBackground_2.jpg'
import {
  CustomCoinIcon,
  CustomHomeIcon,
  CustomMapIcon,
  CustomMedalIcon,
  CustomRankingIcon,
  CustomCloseIcon,
  CustomSettingsIcon,
} from '../../../../components/ui/CustomIcons';
import NewBackground_2 from '../../../../assets/glb/NewBackground_2.jpg';
import { Badge } from '../../../../components/ui/badge';
import { Buttons } from '../../../../components/ui/button';
import svgPaths from '../../../../imports/svg-knollny4nu';
import TopNavBar from '../../../../assets/img/NewUI_Images/top-nav-bg.png';
// import ScreenshotBackground from './ScreenshotBackground';
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

const IconComponent: React.FC<{ type: string; color: string }> = ({
  type,
  color,
}) => {
  const getIconPath = () => {
    switch (type) {
      case 'ranking':
        return svgPaths.p1a822c00;
      case 'home':
        return svgPaths.p3bf15400;
      case 'map':
        return svgPaths.p285e4100;
      case 'settings':
        return svgPaths.p2037cc80;
      case 'coin':
        return svgPaths.p1444db00;
      default:
        return svgPaths.p1444db00;
    }
  };

  return (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
      <path d={getIconPath()} fill={color} />
    </svg>
  );
};
const TopNavButton: React.FC<{ icon: string; onClick?: () => void }> = ({
  icon,
  onClick,
}) => {
  const { primaryColor } = useColor();

  const IconElement = () => {
    switch (icon) {
      case 'home':
        return <CustomHomeIcon color={primaryColor} size={20} />;
      case 'map':
        return <CustomMapIcon color={primaryColor} size={20} />;
      case 'ranking':
        return <CustomRankingIcon color={primaryColor} size={20} />;
      case 'settings':
        return <CustomSettingsIcon color={primaryColor} size={20} />;
      default:
        return <IconComponent type={icon} color={primaryColor} />;
    }
  };

  return (
    <Buttons
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="group relative h-10 w-10 rounded-2xl !px-0 py-0 transition-transform duration-300 hover:scale-110"
      style={{
        borderRadius: '16px',
        boxShadow: '0px 0px 23.386px 0px rgba(0, 0, 0, 0.50)',
        background: `linear-gradient(151.477deg, rgba(${hexToRgb(
          primaryColor,
        )}, 0.3), rgb(0, 0, 0))`,
      }}
    >
      <div
        // className="absolute bottom-[1px] left-[1px] right-[1px]  top-[1px] flex items-center justify-center rounded-2xl"
        className="h-100 w-100 absolute  inset-[2px] flex items-center justify-center rounded-2xl text-sm"
        style={{
          background: `linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
            primaryColor,
          )}, 0.5) 188.68%)`,
          borderRadius: '16px',
          zIndex: 1,
        }}
      >
        {icon === 'ranking' ? (
          <CustomRankingIcon color={primaryColor} className="!h-10 !w-10" />
        ) : icon === 'settings' ? (
          <CustomSettingsIcon
            color={primaryColor}
            className="-mb-1 !h-10 !w-10"
          />
        ) : (
          <IconElement />
        )}
      </div>
    </Buttons>
  );
};

const StatusBar: React.FC<{ label: any; icon?: any }> = ({ label, icon }) => {
  const { primaryColor } = useColor();

  return (
    <div className="flex items-center">
      {icon && (
        <Buttons
          variant="ghost"
          size="sm"
          className="relative h-12 w-12 rounded-2xl !px-0 py-0"
          style={{
            borderRadius: '16px',
            boxShadow: '0px 0px 23.386px 0px rgba(0, 0, 0, 0.50)',
            background: `linear-gradient(151.477deg, rgba(${hexToRgb(
              primaryColor,
            )}, 0.3), rgb(0, 0, 0))`,
          }}
        >
          <div
            className="absolute bottom-[1px] left-[1px] right-[1px] top-[1px] flex items-center justify-center rounded-2xl backdrop-blur-sm"
            style={{
              background: `linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
                primaryColor,
              )}, 0.5) 188.68%)`,
              borderRadius: '16px',
              zIndex: 1,
            }}
          >
            {icon === 'coin' ? (
              <CustomCoinIcon color={primaryColor} className="!h-12 !w-12" />
            ) : icon === 'progress' ? (
              <span
                className="font-rubik text-shadow-[0px_2.867px_8.6px_rgba(0,_255,_187,_0.30)] text-[0.813rem] font-medium tracking-[-0.007rem] text-white"
                style={{ color: primaryColor }}
              >
                {label}%
              </span>
            ) : (
              <IconComponent type={icon} color={primaryColor} />
            )}
          </div>
        </Buttons>
      )}
      {label === '50' ? (
        <div className="relative -ml-2.5 min-w-24 flex-1">
          <div
            className="h-8 w-full overflow-hidden rounded-[0.625rem]"
            style={{
              background: `linear-gradient(179.484deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
                primaryColor,
              )}, 0.4) 188.68%)`,
              border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.1)`,
              boxShadow: '0px 0px 15.3543px 0px rgba(0,0,0,0.5)',
            }}
          >
            <div
              className="h-full rounded-[0.625rem] shadow-[0px_0px_2.378px_0px_rgba(0,_255,_187,_0.30)_inset,_0px_2.867px_8.6px_0px_rgba(0,_255,_187,_0.60)] transition-all duration-500 ease-out"
              style={{
                width: `${(Number(label) / 100) * 100}%`,
                backgroundColor: primaryColor,
                boxShadow: `0px 0px 9.93511px 0px rgba(184,184,184,0.2)`,
              }}
            />
          </div>
        </div>
      ) : (
        <Badge
          variant="secondary"
          className="font-rubik -ml-1.5 flex h-8 min-w-24 items-center rounded-[0.625rem] px-4"
          style={{
            background: `linear-gradient(170.484deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
              primaryColor,
            )}, 0.4) 188.68%)`,
            border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.2)`,
            boxShadow: '0px 0px 23.3864px 0px rgba(0,0,0,0.5)',
          }}
        >
          <span className="text-[0.813rem] font-medium text-white">
            {label}
          </span>
        </Badge>
      )}
    </div>
  );
};
interface InteractionScreenShotProps {
  currentInteractionIndex?: number;
  interactionquestionData?: any;
  data?: any;
  options?: any;
  backGroundImg?: any;
  option?: any;
  geTfeedBackoption?: any;
  isScreenshot?: any;
  preloadedAssets?: any;
  profileData?: any;

  currentScreenId?: number;
  QuestContentByLanguage: any;
  gameInfo: any;
  InterActionScore: any;
  NonPlayerNameLanguage: any;
  QuestbackgroundGlb?: any;
}

const InteractionScreenShotFutureTheme: React.FC<
  InteractionScreenShotProps
> = ({
  currentInteractionIndex,
  interactionquestionData,
  data,
  backGroundImg,
  option,
  options,
  geTfeedBackoption,
  isScreenshot,
  preloadedAssets,
  profileData,
  currentScreenId,
  QuestContentByLanguage,
  gameInfo,
  InterActionScore,
  NonPlayerNameLanguage,
  QuestbackgroundGlb,
}) => {
  const [ReOrderedOptions, setReOrderedOptions] = useState<any>(null);
  const { profile, setProfile } = useContext(ScoreContext);
  const [progressPercent, setProgressPercent] = useState<any>(0);
  const [totalPoints, settotalPoints] = useState<any>(InterActionScore ?? 0);
  const [preloaded, setPreloaded] = useState(preloadedAssets);

  const matchedAsset = preloaded?.BackgroundScreenshots?.find(
    (item: any) =>
      item?.name?.trim() === gameInfo?.assets?.gasAssetName?.trim(),
  );

  let contentRef = useRef<any>(null);
  let optionRef = useRef<any>([]);

  const progressResult = () => {
    //calculate Progress based on screen, Need to show different progress for current screen is in story, progress of the current quest, unless  show the entire game progress
    const currentQuestBlocks = gameInfo.blocks[profile.currentQuest];
    const totalblockCount =
      currentQuestBlocks && Object.keys(currentQuestBlocks).length;
    const keyWithValueOfCurrentBlock =
      currentQuestBlocks &&
      Object.keys(currentQuestBlocks).find((key: any) => {
        const obj = currentQuestBlocks[key];
        const blockPrimarySequence = obj?.blockPrimarySequence;
        if (blockPrimarySequence) {
          const hasMatchingSequence =
            blockPrimarySequence.trim() ===
            (data[0]?.blockPrimarySequence || '').trim();
          return hasMatchingSequence;
        }
        return false;
      });
    const progressBarRatio: any =
      keyWithValueOfCurrentBlock &&
      (parseInt(keyWithValueOfCurrentBlock) > 0
        ? (parseInt(keyWithValueOfCurrentBlock) - 1) / totalblockCount
        : 0);
    setProgressPercent(
      progressBarRatio && progressBarRatio > 0 ? progressBarRatio : 0,
    );
  };
  useEffect(() => {
    // const selectedIndex = options ? options?.findIndex((item: any) => item.qpOptions === option) : null;
    const getTotalPoint = options
      ? options?.filter((item: any) => item.qpOptions === option)
      : null;

    progressResult();
  }, []);

  const handleShowSelectedOption = () => {
    setTimeout(() => {
      const selectedElement: any = document.getElementsByClassName('Selected');
      const screenShotQuestion: any = document.getElementsByClassName(
        'story_screenshot_interaction_question',
      );
      const element: any = document.getElementById('scrollbar');

      if (!options || options.length === 0) return;
      if (!selectedElement || selectedElement.length === 0) return;
      if (!screenShotQuestion || screenShotQuestion.length === 0) return;
      if (!element) return;

      const getOptionsHeight = options.map((item: any) => {
        const el = document.getElementById(item?.qpOptions);
        return el ? el.scrollHeight : 0; // SAFE DEFAULT
      });

      const alphaIndex = options.findIndex(
        (item: any) => item?.qpOptions === selectedElement[0]?.title,
      );

      if (alphaIndex < 0) return;

      const totalHeight = getOptionsHeight
        .slice(0, alphaIndex)
        .reduce((acc: number, tot: number) => acc + (tot || 0), 0);

      const questionHeight = screenShotQuestion[0]?.scrollHeight || 0;

      element.scrollTop = totalHeight + questionHeight;
    }, 50);
  };

  useEffect(() => {
    handleShowSelectedOption();
  }, [options]);
  const { primaryColor } = useColor();

  const currentInteractionOptions =
    interactionquestionData.interactionoptions?.[currentInteractionIndex]
      ?.optionsdetails?.optiontext ?? [];

  return (
    <>
      {preloadedAssets.parch && (
        <div>
          <div
            className="feedback_screenshot"
            style={{
              backgroundImage: `url(${QuestbackgroundGlb ?? NewBackground_2})`,
              backgroundSize: 'cover',
              filter: 'contrast(70%)',
              backgroundRepeat: 'no-repeat',
              boxShadow: 'inset 0px 5px 100px 25px white',
              borderRadius: '20px',
              position: 'relative',
            }}
          >
            {/* Add BackgroundGLB as the background */}

            <div className="h-full w-full">
              <div className="relative  h-full bg-cover bg-center bg-no-repeat">
                <div
                  className="relative flex w-full px-4 pb-4 sm:px-6 sm:pb-6 lg:px-8 lg:pb-8"
                  style={{ height: '100%' }}
                >
                  {/* Interaction Content */}
                  <div className="flex-grow-1 flex h-full flex-col items-end justify-center ">
                    <div
                      className="relative flex h-full max-h-fit w-full max-w-lg flex-col items-center justify-start gap-5 overflow-hidden rounded-[2.375rem] p-5 pb-6 backdrop-blur-[3.724rem] backdrop-filter"
                      style={{
                        background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${hexToRgb(
                          primaryColor,
                        )}, 0.2) 127.18%)`,
                      }}
                    >
                      {/* Interaction Title */}
                      <div className="relative">
                        <h1
                          className="text-center text-4xl font-normal tracking-[0.005rem]"
                          style={{
                            color: primaryColor,
                            textShadow: `rgba(${hexToRgb(
                              primaryColor,
                            )}, 0.5) 0px 0px 9px`,
                          }}
                        >
                          Interaction
                        </h1>
                      </div>

                      {/* Decorative Line */}
                      <div className="relative flex w-full items-center justify-center">
                        <div className="w-full">
                          <div className="relative h-[1px] w-full">
                            <svg
                              className="block h-[1px] w-full"
                              fill="none"
                              preserveAspectRatio="none"
                              viewBox="0 0 533 1"
                            >
                              <line
                                stroke={`url(#paint0_linear_interaction_${primaryColor.replace(
                                  '#',
                                  '',
                                )})`}
                                x2="532.526"
                                y1="0.5"
                                y2="0.5"
                              />
                              <defs>
                                <linearGradient
                                  gradientUnits="userSpaceOnUse"
                                  id={`paint0_linear_interaction_${primaryColor.replace(
                                    '#',
                                    '',
                                  )}`}
                                  x1="532.526"
                                  x2="0"
                                  y1="0.999899"
                                  y2="0.99992"
                                >
                                  <stop
                                    stopColor={primaryColor}
                                    stopOpacity="0"
                                  />
                                  <stop
                                    offset="0.484375"
                                    stopColor={primaryColor}
                                    stopOpacity="0.994792"
                                  />
                                  <stop
                                    offset="1"
                                    stopColor={primaryColor}
                                    stopOpacity="0"
                                  />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </div>

                      {/* Question Section */}
                      <div className="max-h-[350px] w-full overflow-y-auto">
                        <div
                          className="relative mb-6 flex w-full flex-row items-center justify-start gap-1.5 p-0 leading-[0]"
                          style={{ color: primaryColor }}
                        >
                          {/* Q5 Badge */}
                          <div className="relative flex w-[1.8rem] flex-row items-center justify-between p-0 shadow-[0px_0.993175px_3.9727px_0px_rgba(0,0,0,0.25)]">
                            <div className="text-shadow-[0px_7.48192px_18.1751px_rgba(0,0,0,0.46)] relative flex h-[0.688rem] w-[0.938rem] flex-col justify-center text-[1.316rem]">
                              <p className="block leading-[normal]">Q</p>
                            </div>
                            <div className="text-shadow-[0px_7.48192px_18.1751px_rgba(0,0,0,0.46)] relative flex h-[1.152rem] w-[0.715rem] flex-col justify-center text-[1.277rem]">
                              <p className="block leading-[normal]">s</p>
                            </div>
                          </div>

                          {/* Question Text */}
                          <div className="font-rubik relative flex flex-col justify-center text-justify text-[1.185rem] font-medium tracking-[-0.0744148px]">
                            <p className="block leading-tight">
                              {
                                interactionquestionData.interactionquestion[
                                  currentInteractionIndex
                                ]?.blockText
                              }
                            </p>
                          </div>
                        </div>

                        {/* Options Section */}
                        {/* Options Section (UI same as old design + logic from second snippet) */}
                        <div className="flex w-full flex-col items-start justify-center gap-4">
                          {currentInteractionOptions.map(
                            (qpOpt: string, index: number) => {
                              // const isSelected =
                              //   interactionquestionData.questoptionchoose?.[currentInteractionIndex].qpOptionText === qpOpt;
                              const selectedOption =
                                interactionquestionData.questoptionchoose?.[
                                  currentInteractionIndex
                                ]?.qpOptionText ??
                                interactionquestionData.questoptionchoose?.[0]
                                  ?.qpOptionText;

                              const isSelected = selectedOption === qpOpt;
                              return (
                                <div key={qpOpt} className="w-full">
                                  {/* Outer clickable box */}
                                  <div
                                    className={`relative mb-4 w-full cursor-pointer rounded-[0.395rem] transition-all duration-200`}
                                    style={{
                                      backgroundColor: 'transparent',
                                      border: 'none',
                                    }}
                                    // onClick={() => handleOptionSelect(item)}
                                    ref={optionRef}
                                    id={qpOpt}
                                    title={qpOpt}
                                  >
                                    <div className="relative flex h-full w-full flex-row items-center justify-center">
                                      <div className="relative box-border flex w-full flex-row content-stretch items-center justify-start gap-2 px-2 py-1.5">
                                        {/* TEXT */}
                                        <div
                                          className="font-rubik relative flex flex-col justify-center text-[1.194rem] leading-none"
                                          // style={{
                                          //   color: isSelected
                                          //     ? primaryColor
                                          //     : 'rgba(255,255,255,0.9)',
                                          // }}
                                          style={{
                                            color: isSelected
                                              ? `rgba(${hexToRgb(
                                                  primaryColor,
                                                )}, 1)`
                                              : 'rgba(255,255,255,0.7)',

                                            fontWeight: isSelected
                                              ? '700'
                                              : '400',

                                            backgroundColor: isSelected
                                              ? `rgba(${hexToRgb(
                                                  primaryColor,
                                                )}, 0.)`
                                              : 'transparent',
                                          }}
                                        >
                                          <p className="block leading-tight">
                                            {`${qpOpt}`}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {index <
                                    currentInteractionOptions.length - 1 && (
                                    <div className="relative flex w-full items-center justify-center">
                                      <div className="w-full">
                                        <div className="relative h-[1px] w-full">
                                          <svg
                                            className="block h-[1px] w-full rotate-180"
                                            fill="none"
                                            preserveAspectRatio="none"
                                            viewBox="0 0 533 1"
                                          >
                                            <line
                                              stroke="url(#paint0_linear_divider)"
                                              x2="532.526"
                                              y1="0.5"
                                              y2="0.5"
                                            />
                                            <defs>
                                              <linearGradient
                                                id="paint0_linear_divider"
                                                x1="0"
                                                x2="532.526"
                                                y1="1.5"
                                                y2="1.5"
                                                gradientUnits="userSpaceOnUse"
                                              >
                                                <stop stopColor="white" />
                                                <stop
                                                  offset="1"
                                                  stopColor="#3D3D3D"
                                                />
                                              </linearGradient>
                                            </defs>
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            },
                          )}
                        </div>
                      </div>

                      {/* Background Ellipse */}
                      <div className="pointer-events-none absolute left-[11.81rem] top-[2.435rem] h-[43.427rem] w-[28.455rem] mix-blend-hard-light">
                        <div className="absolute bottom-[-61.407%] left-[-93.717%] right-[-93.717%] top-[-61.407%]">
                          <svg
                            className="block h-full w-full"
                            fill="none"
                            preserveAspectRatio="none"
                            viewBox="0 0 1309 1549"
                          >
                            <g
                              filter={`url(#filter0_f_interaction_${primaryColor.replace(
                                '#',
                                '',
                              )})`}
                              id="Ellipse 7189"
                              opacity="0.1"
                              style={{ mixBlendMode: 'hard-light' }}
                            >
                              <ellipse
                                cx="654.639"
                                cy="774.418"
                                fill={primaryColor}
                                rx="227.639"
                                ry="347.418"
                              />
                            </g>
                            <defs>
                              <filter
                                colorInterpolationFilters="sRGB"
                                filterUnits="userSpaceOnUse"
                                height="1548.19"
                                id={`filter0_f_interaction_${primaryColor.replace(
                                  '#',
                                  '',
                                )}`}
                                width="1308.63"
                                x="0.325104"
                                y="0.325104"
                              >
                                <feFlood
                                  floodOpacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feBlend
                                  in="SourceGraphic"
                                  in2="BackgroundImageFix"
                                  mode="normal"
                                  result="shape"
                                />
                                <feGaussianBlur
                                  result="effect1_foregroundBlur_39_61"
                                  stdDeviation="213.337"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                      </div>

                      {/* Inset Shadow Border */}
                      <div
                        className="pointer-events-none absolute inset-0 rounded-[2.375rem]"
                        style={{
                          boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                            primaryColor,
                          )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                            primaryColor,
                          )}, 0.2)`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InteractionScreenShotFutureTheme;
